import {
  EKwikUIInputEmailCase,
  EKwikUIInputEmailSize
} from "./input-email.definitions";

export const DEFAULT_VALUES = {
  case: EKwikUIInputEmailCase.DEFAULT,
  disabled: false,
  domains: ["gmail.com", "yahoo.com", "hotmail.com", "outlook.com", "aol.com"],
  focus: false,
  formControlName: "form_control_input_email",
  hintContent: "",
  icon: "",
  id: "input",
  invalid: false,
  label: "Input Email",
  placeholder: "Please enter email",
  postfix: "",
  prefix: "",
  size: EKwikUIInputEmailSize.L
};

export const VALIDATE_KEY_VALUES = {
  case: true,
  disabled: true,
  domains: true,
  focus: true,
  formControlName: true,
  hintContent: true,
  icon: true,
  id: true,
  invalid: true,
  label: true,
  placeholder: true,
  postfix: true,
  prefix: true,
  size: true
};
